import { Component, EventEmitter, Input, Output, effect, inject, input, signal } from '@angular/core';
import { UiTranslateService } from '../../helper/lang';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Component({
  standalone: false,
  selector: 'ig-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
  readonly #http = inject(HttpClient);
  readonly #sanitizer = inject(DomSanitizer);
  readonly #translate = inject(UiTranslateService);




  @Output() createBtnClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() openApiDocu: EventEmitter<string> = new EventEmitter<string>();


  /**
   * The message that is displayed for users with at least write-rights
   */
  @Input() message?: string;

  /**
   *  The message that is displayed for readOnly users (readOnly-input true)
   */
  @Input() messageReadOnly?: string;

  /**
   * Headline if readOnly=false
   */
  @Input() messageHeadline?: string;

  /**
   * Headline if readOnly=true
   */
  @Input() messageHeadlineReadOnly?: string;

  /**
   * Src for the shown image
   */
  imageSrc = input<string>();

  /**
   * Link that is opened in new tab via the Product Documentation Btn. The Button is only displayed if this has a value
   */
  @Input() fullProductDocumentationLink?: string;

  /**
   * String that is given back with the openApiDocu-Output emitted if the Button is clicked. The Api-Btn is only displayed if this has a value
   */
  @Input() apiDocumentationLink?: string;

  /**
   * Label for the create Btn
   */
  @Input() createBtnLabel = this.#translate.instant('PRICEBOX.CREATE');

  /**
   * If this has no value, the create btn is not displayed. You may fill it dynamically with the link of the btn
   */
  @Input() createBtn: string = '';

  /**
   * Disables the displayed Create Btn
   */
  @Input() createBtnDisabled: boolean = false;

  /**
   * If not empty a tooltip is placed on the create button
   */
  @Input() createBtnTooltipText?: string;

  /**
   * Set this input with the information about the current users rights. If true, the create btn is not displayed and the readOnly texts are shown
   */
  @Input() readOnly: boolean = true;

  productInfoLink = input<string>();

  svgData = signal<SafeHtml>('');

  disclaimer = input<string>();


  constructor() {
    effect(() => {
      const imgSrc = this.imageSrc();
      if (imgSrc) {
        this.#http.get(imgSrc, { responseType: 'text' }).pipe(
          map(svg => svg.replace(/<\/?\??(xml)[^>]*>/gm, '')), // remove xml tag,
          map(svg => this.#sanitizer.bypassSecurityTrustHtml(svg))
        ).subscribe(svgData => {
          this.svgData.set(svgData);
        })

      }
    }, { allowSignalWrites: true });
  }



  onCreateBtnClick() {
    this.createBtnClicked.emit();
  }

  onApiDocuBtnClicked() {
    this.openApiDocu.emit(this.apiDocumentationLink);
  }

  openInNewTab(link: string) {
    window.open(link, '_blank')
  }
}
